import { toPersianDigits } from '@bookora/shared';
/**
 * The engine's own words. A single digit between two words is bidi-safe, so
 * «۲ از ۴» needs no isolate.
 */
export const DEFAULT_COACHMARK_LABELS = {
    next: 'بعدی',
    prev: 'قبلی',
    finish: 'متوجه شدم',
    skip: 'رد کردن راهنما',
    close: 'بستن راهنما',
    backToGuide: 'بازگشت به راهنما',
    counter: (n, total) => `${toPersianDigits(n)} از ${toPersianDigits(total)}`,
    // Position only: focus lands on the step's heading, which already speaks
    // the title — repeating it here made every step say its title twice.
    liveStep: (n, total) => `مرحلهٔ ${toPersianDigits(n)} از ${toPersianDigits(total)}`,
};
//# sourceMappingURL=labels.js.map